<div class="title mb-4">
  <h2>MANAGE CHAT AI</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <!-- Table -->
      <section>
        <div class="btn-group mb-3">
          <button class="btn btn-primary" (click)="openUploadModal(modalUpload)">
            <i class="fa-solid fa-plus"></i> Upload
          </button>
          <button class="btn btn-dark" (click)="openUploadModal(modalUploadURL)">
            <i class="fa-solid fa-plus"></i> Upload By URL
          </button>
        </div>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">
                  File
                </th>
                <th scope="col">
                  Upload Date
                </th>
                <th scope="col">
                  URL
                </th>
                <th scope="col">
                  Note
                </th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dataFiles; let index  = index">
                <th scope="row">{{ index + 1 }}</th>
                <td>
                  <a style="color: black" hre>{{ row.file_name }}</a>
                </td>
                <td>
                  <a style="color: black" hre>{{ row.upload_date }}</a>
                </td>
                <td>
                  <a style="color: #009dff" href="{{ row.url }}" target="_blank">{{ row.url }}</a>
                </td>
                <td>
                  <a style="color: black" hre>{{ row.note ?? '-' }}</a>
                </td>
                <td>
                  <button class="btn btn-danger btn-sm" (click)="handleDelete(row.file_name)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>

              <tr *ngIf="dataFiles.length == 0">
                <td colspan="12" style="text-align: center">No Data</td>
              </tr>
            </tbody>
          </table>

        </div>
      </section>
      <!-- Table -->
    </div>
  </div>
</div>


<ng-template #modalUpload let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="ml-auto">
            <h3>Add New File</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-12 mx-auto">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group ">
              <div class="input-group mb-3">
                <div class="custom-file">
                  <input type="file" class="custom-file-input" (change)="onFileChange($event)" accept=".pdf,.doc,.docx"
                    id="inputGroupFile01" aria-describedby="inputGroupFileAddon01">
                  <label class="custom-file-label w-100" for="inputGroupFile01">{{ fileName }}</label>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center" style="padding: 4px; width: 100%">
              <button (click)="uploadFiles()" class="btn btn-success">
                <i class="fa-solid fa-save"></i> Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #modalUploadURL let-modal>
  <div class="modal-content">
    <div class=""></div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 d-flex">
          <div class="ml-auto">
            <h3>Add New File From URL</h3>
          </div>
          <div class="ml-auto">
            <i (click)="modalService.dismissAll()" class="fa fa-window-close pointer" aria-hidden="true"></i>
          </div>
        </div>
      </div>
      <div class="edit_cat_modal col-md-12 mx-auto">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group ">
              <label for="">URL</label>
              <input type="text" class="form-control" [(ngModel)]="file" placeholder="Paste your URL...">
            </div>
            <div class="form-group ">
              <label for="">Note</label>
              <input type="text" class="form-control" [(ngModel)]="note" placeholder="Enter Your Note">
            </div>
            <div class="d-flex justify-content-center" style="padding: 4px; width: 100%">
              <button (click)="uploadFiles(true)" class="btn btn-success">
                <i class="fa-solid fa-save"></i> Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>